module.exports = __webpack_public_path__ + "static/media/man1.aff2005d.svg";